export const webConfisyConstants = {
  LIST_CONFISYS_REQUEST: 'LIST_CONFISYS_REQUEST',
  LIST_CONFISYS_SUCCESS: 'LIST_CONFISYS_SUCCESS',
  LIST_CONFISYS_FAILURE: 'LIST_CONFISYS_FAILURE'
};
